import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import RecordBadge from '../common/RecordBadge';

/** Up to three card names, "A, B and C" (a bundle's `preview` is its first four). */
function namesLine(pkg) {
	const names = (Array.isArray(pkg.preview) ? pkg.preview : []).map((c) => c?.name).filter(Boolean).slice(0, 3);
	if (!names.length) return '';
	if (names.length === 1) return names[0];
	return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

/**
 * One line above the new card form (KPR-1440): "Discover has <package>, with
 * <its cards>." and a link to it. Never more than the one line; it blocks
 * nothing, and Dismiss hides it for as long as the form is open.
 */
export default function DiscoverHint({ pkg, onDismiss }) {
	if (!pkg) return null;
	const cards = namesLine(pkg);
	return (
		<div className='discover-hint' role='status' data-testid='discover-hint'>
			<span className='discover-hint__text'>
				{'Discover has '}
				<RecordBadge
					kind={pkg.kind === 'collection' ? 'collection' : 'card'}
					record={{ icon: pkg.icon, color: pkg.color, name: pkg.name }}
					title={pkg.name}
					size='xs'
				/>
				{cards ? `, with ${cards}.` : '.'}
			</span>
			<span className='discover-hint__actions'>
				<Link to={`/discover/${encodeURIComponent(pkg.key)}`}>View it</Link>
				<Button type='text' size='small' onClick={onDismiss}>Dismiss</Button>
			</span>
		</div>
	);
}
